import { createTheme } from "@mui/material/styles";

import { blueGrey, grey } from "@mui/material/colors";

const backgroundImages = [
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-10.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-11.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-12.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-13.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-14.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-15.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-16.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-17.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-18.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-19.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-20.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-21.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-22.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-23.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-24.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-25.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-26.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-27.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-28.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-29.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-30.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-31.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-32.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-33.jpg)",
  "url(https://nowbuttons.com/src/images/app/webapp_unplash_background-34.jpg)",
];

const randomBg =
  backgroundImages[Math.floor(Math.random() * backgroundImages.length)];

export default createTheme({
  palette: {
    primary: { main: "#00aa00" },
    secondary: { main: blueGrey[900] },
    text: {
      secondary: "rgba(0, 0, 0, 0.4)",
    },
    warning: { main: "#FFC260" },
    info: { main: "#9013FE" },
    success: { main: "#3CD4A0" },
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    subtitle1: {
      fontWeight: 500,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          "@media (min-width:600px)": {
            backgroundImage: randomBg,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            backgroundAttachment: "fixed",
            backgroundSize: "cover",
          },
          "@media print": {
            backgroundImage: "none",
          },
        },
        pre: {
          padding: 8,
          backgroundColor: grey[200],
          overflow: "auto",
          fontSize: 14,
          whiteSpace: "normal",
          wordBreak: "break-all",
        },
        code: {
          whiteSpace: "pre",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          boxShadow: "none",
          "&:active": {
            boxShadow: "none",
          },
        },
        sizeLarge: {
          textTransform: "capitalize",
          alignItems: "flex-start",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "standard",
        size: "small",
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: "standard",
      },
      styleOverrides: {
        select: {
          "&:focus": {
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginBottom: 16,
        },
      },
      defaultProps: {
        variant: "standard",
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: "rgba(0, 0, 0, 0.7)",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginBottom: 16,
        },
      },
    },
    MuiLink: {
      defaultProps: {
        underline: "none",
      },
      styleOverrides: {
        button: {
          "&:disabled": {
            color: "rgba(0, 0, 0, 0.26)",
            "&:hover": {
              textDecoration: "none",
            },
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          margin: "16px 0",
          border: "1px solid rgba(0, 0, 0, .125)",
          boxShadow: "none",
          "&:before": {
            display: "none",
          },
        },
        rounded: {
          borderRadius: 4,
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          "&.Mui-expanded": {
            minHeight: "auto",
          },
        },
        content: {
          alignItems: "center",
          "&.Mui-expanded": {
            margin: "12px 0",
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          display: "block",
        },
      },
    },
  },
});
